module.exports = "<p class=\"zuweisung\" *ngIf=\"userCanAssign()\">{{ zuweisung }}</p>"